"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.TOOLTIP_OFFSET = void 0;
const react_1 = __importStar(require("react"));
const react_slot_1 = require("@radix-ui/react-slot");
const RadixTooltip = __importStar(require("@radix-ui/react-tooltip"));
const Tooltip_styles_1 = require("./Tooltip.styles");
exports.TOOLTIP_OFFSET = 4;
const TOOLTIP_ARROW_WIDTH = 12;
const TOOLTIP_ARROW_HEIGHT = 6;
const TOOLTIP_CONTENT_BORDER_RADIUS = 4;
const TOOLTIP_DELAY_DURATION = 300;
const Root = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Tooltip_styles_1.StyledTooltip, Object.assign({ ref: forwardedRef, delayDuration: TOOLTIP_DELAY_DURATION }, props), children));
});
/**
 * A `span` wrapper around the element that the tooltip is displayed on when hovered.
 */
const Trigger = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children, asChild } = _a, props = __rest(_a, ["children", "asChild"]);
    const Comp = asChild ? react_slot_1.Slot : Tooltip_styles_1.StyledTriggerSpan;
    return (react_1.default.createElement(Tooltip_styles_1.StyledTriggerTooltip, { asChild: true },
        react_1.default.createElement(Comp, Object.assign({ ref: forwardedRef }, props), children)));
});
const Arrow = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement(Tooltip_styles_1.StyledArrowTooltip, Object.assign({ ref: forwardedRef, width: TOOLTIP_ARROW_WIDTH, height: TOOLTIP_ARROW_HEIGHT }, props)));
});
const Content = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(RadixTooltip.Portal, null,
        react_1.default.createElement(Tooltip_styles_1.StyledContentTooltip, Object.assign({ ref: forwardedRef, sideOffset: exports.TOOLTIP_OFFSET, hideWhenDetached: true, arrowPadding: TOOLTIP_CONTENT_BORDER_RADIUS }, props),
            children,
            react_1.default.createElement(Arrow, null))));
});
const Provider = RadixTooltip.Provider;
Root.displayName = "Tooltip";
Trigger.displayName = "Tooltip.Trigger";
Arrow.displayName = "Tooltip.Arrow";
Content.displayName = "Tooltip.Content";
Provider.displayName = "Tooltip.Provider";
const Tooltip = Object.assign(Root, {
    Trigger: Trigger,
    Content: Content,
    Provider: Provider,
});
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map